<template>
  <div :class="$style.captcha">
    <header :style="{ backgroundColor: color }">
      <span>滑动验证</span>
    </header>
    <main>
      <div id="captcha" :class="$style.instance"></div>
    </main>
  </div>
</template>

<script>
import { CaptchaInit } from "@/libs/captcha"

export default {
  name: '',
  data() {
    return {
      errCount: 0,
      color: '#BA1122'
    };
  },
  created() {
    this.setColor()
  },
  mounted() {
    this.captchaSdkInit()
  },
  methods: {
    setColor() {
      const { color } = this.$route.query;
      this.color = `#${color}`;
      setTimeout(() => {
        const bgGreen = document.getElementsByClassName('bg-green')[0];
        if (bgGreen) bgGreen.style.backgroundColor = `#${color}`;
      },200)
    },
    captchaSdkInit() {
      CaptchaInit('captcha', (data) => {
        window.webkit.messageHandlers.transmitCaptchaInfo.postMessage(JSON.stringify(data))
      }, (err) => {
        this.errCount = this.errCount + 1;
        if (this.errCount < 10) {
          setTimeout(() => {
            this.captchaSdkInit()
          }, 500);
        }
      })
    }
  }
}
</script>

<style lang="scss" module>
.captcha {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
  > header {
    position: relative;
    text-align: center;
    line-height: 22px;
    height: 40px;
    background-color: #BA1122;
    > span {
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
    }
    .fanhui {
      position: absolute;
      top: 17px;
      right: 17px;
      width: 17px;
      height: 12px;
    }
  }
    > main {
      padding: 17px 10px;
      overflow-y: auto;
      :global {
        #captcha {
          position: absolute;
          width: 280px;
          left: 0;
          right: 0;
          margin: auto;
          top: 75px;
          .nc_1_nocaptcha {
            .nc_wrapper {
              width: 100%;
              .nc_scale {
                background-color: #c8c4bf;
              }
              .scale_text {
                border-radius: 5px;
                box-shadow: 0 0 7px #c8c4bf;
                overflow: hidden;
              }
              .nc-lang-cnt {
                -webkit-text-fill-color: #ffffff;
                color: #ffffff;
                padding-left: 30px;
                font-weight: bold;
              }
              .nc_iconfont {
                height: 34px;
                border-radius: 5px;
                animation: none;
                background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/wanXin/orangeTheme/jiantou_1.png') no-repeat;
                background-size: 100% 100%;
                background-position: center;
                font-size: 0;
              }
              .nc_bg {
                background-color: #BA1122;
              }
            }
          }
        }
      }
    }
}
</style>